import {batch} from 'react-redux';

import {setTopMenuProperties, showAlert, updateActiveMenu} from '@/actions/setupActions';
import {setGeoArea, setInit, setIsAutoSync, setRegion, updateTimeZone} from '@/actions/timeZoneAction';
import {
  getAutoTimeZoneSystem,
  getDateTimeLocalSystem,
  getDateTimeServerSystem,
  getTimeZoneAreasSystem,
  postTimeZoneRegionsSystem,
} from '@/api/systemApi';
import {ALERT_TYPE} from '@/constants/enums';
import {SYSTEM_LOG, DEVICE_SETTING_ADDRESS, TIMEZONE} from '@/constants/pcConstAppData';
import {navigateTo} from '@/libs/appHelper';
import {normalizeDateFormat} from '@/libs/dateHelper';
import {formatMessage} from '@/libs/intlHelper';
import {getAreaAndOrigin} from '@/libs/timezoneHelper';

// #region DeviceSettingDateTime

async function getDateTime(isInitialize, isAutoSync, timeZoneStore, dispatch) {
  if (isAutoSync) {
    const timeZone = await getDateTimeServerSystem(true);
    if (timeZone.Date !== null) {
      const zone = getAreaAndOrigin(timeZone.Zone);
      const date = normalizeDateFormat({day: timeZone.Day, month: timeZone.Month, year: timeZone.Year});

      return {
        isAutoSync,
        geoArea: zone.geoArea,
        region: zone.region,
        date,
        time: timeZone.Time,
      };
    }
    dispatch(showFailedAutoTimezoneToast());
  }

  if (isInitialize) {
    const resTimeZone = await getDateTimeLocalSystem(true);
    const zone = getAreaAndOrigin(resTimeZone.Zone);
    const date = normalizeDateFormat({day: resTimeZone.Day, month: resTimeZone.Month, year: resTimeZone.Year});

    return {
      isAutoSync,
      geoArea: zone.geoArea,
      region: zone.region,
      date,
      time: resTimeZone.Time,
    };
  }

  return {
    isAutoSync,
    geoArea: timeZoneStore.geoArea,
    region: timeZoneStore.region,
    date: timeZoneStore.date,
    time: timeZoneStore.time,
  };
}

function showFailedAutoTimezoneToast() {
  return (dispatch) => {
    dispatch(
      showAlert({
        alertShow: true,
        alertText: formatMessage({id: 'toast.deviceSetting.failedAutoTimezone.message'}),
        alertStyle: ALERT_TYPE.ALERT_DANGER,
      }),
    );
  };
}

export function initTimeZone() {
  return async (dispatch, getState) => {
    try {
      const {timeZoneStore} = {...getState()};
      const {origin} = timeZoneStore;

      if (origin) return;

      const resIsAutoSync = await getAutoTimeZoneSystem();
      const isInitialize = true;

      const dataOrigin = await getDateTime(isInitialize, resIsAutoSync, timeZoneStore, dispatch);

      dispatch(
        setInit({
          ...dataOrigin,
          origin: dataOrigin,
        }),
      );
    } catch (error) {
      console.log('initTimeZone error', error);
    }
  };
}

export function changeAutoSync(isAutoSync) {
  return async (dispatch, getState) => {
    try {
      const {timeZoneStore} = {...getState()};
      dispatch(setIsAutoSync(isAutoSync));
      const isInitialize = false;

      const dataOrigin = await getDateTime(isInitialize, isAutoSync, timeZoneStore, dispatch);

      dispatch(
        updateTimeZone({
          ...dataOrigin,
        }),
      );
    } catch (error) {
      console.log('initTimeZone error', error);

      dispatch(showFailedAutoTimezoneToast());
    }
  };
}

// #endregion

// #region TimezoneSetting

export function initTimeZoneArea() {
  return async (dispatch, getState) => {
    let areas = [];
    let selectedArea = -1;
    let regions = [];
    let selectedRegion = -1;

    try {
      // NOTE: handle top menu
      batch(() => {
        dispatch(updateActiveMenu(SYSTEM_LOG));
        dispatch(
          setTopMenuProperties({
            topButtonProperties: undefined,
            backButtonProperties: {
              // id: backButtonProperties.id,
              // label: backButtonProperties.label,
              disabled: true,
              // onClick: backButtonProperties.onClick,
            },
            titleMenuProperties: TIMEZONE,
            topButtonSecondaryButtonProperties: undefined,
            topButtonTertiaryProperties: undefined,
          }),
        );
      });

      // NOTE: handle refresh from timezone setting page
      await dispatch(initTimeZone());

      const {timeZoneStore} = {...getState()};
      const {geoArea, region} = timeZoneStore;

      const resAreas = await getTimeZoneAreasSystem();
      const resRegions = await postTimeZoneRegionsSystem(geoArea);

      areas = getAreaOptions(resAreas);
      selectedArea = geoArea;
      regions = getRegionOptions(resRegions);
      selectedRegion = region;
    } catch (error) {
      console.log('initTimeZoneArea error', error);
    }

    return {
      areas,
      selectedArea,
      regions,
      selectedRegion,
    };
  };
}

export function cancelTimeZoneSetting() {
  return () => {
    navigateTo(DEVICE_SETTING_ADDRESS);
  };
}

export function saveTimeZoneSetting(selectedArea, selectedRegion) {
  return async (dispatch) => {
    batch(() => {
      dispatch(setGeoArea(selectedArea));
      dispatch(setRegion(selectedRegion));
    });

    navigateTo(DEVICE_SETTING_ADDRESS);
  };
}

export function changeArea(selectedArea) {
  return async () => {
    let regions = [];
    let selectedRegion = -1;

    try {
      const resRegions = await postTimeZoneRegionsSystem(selectedArea);

      regions = getRegionOptions(resRegions);
      // eslint-disable-next-line prefer-destructuring
      selectedRegion = resRegions[0];
    } catch (error) {
      console.log('changeArea error', error);
    }

    return {
      regions,
      selectedRegion,
    };
  };
}

// #endregion

function getAreaOptions(data) {
  return data.map((e) => ({label: e, value: e}));
}

function getRegionOptions(data) {
  return data.map((e) => ({label: e.split('_').join(' '), value: e}));
}
